export default __webpack_public_path__ + "static/media/aalok_niroula.4f0881f0.jpg";